

export const COLORS = {
  1: "rise",
  "-1": "fall",
  "-2": ""
};

const STATUS = {
  1: {
    mark: "+",
    _mark: "+",
    color: COLORS[1]
  },
  "-1": {
    mark: "", // 负数带有负号，置空
    _mark: "-", // 副本
    color: COLORS[-1]
  },
  0: {
    mark: "",
    color: ""
  }
};
export function comparePrice(lastPrice, preClosePrice) {
  if (preClosePrice == undefined) {
    return 0;
  }
  const change = lastPrice - preClosePrice;
  return Math.sign(change);
}

/**
 * 获取股票状态
 * @param {*} lastPrice 最新价
 * @param {*} preClosePrice 昨收价
 * @returns
 */
export function getValueStatus(lastPrice, preClosePrice) {
  const sign = comparePrice(lastPrice, preClosePrice);
  return { sign, ...(STATUS[sign] || {}) };
}


// 四舍五入保留指定位数
function preciseRound(number, digits = 2) {
  const factor = Math.pow(10, digits);
  return (Math.round(number * factor) / factor).toFixed(digits);
}

export function formatAmount(amount, digits = 2) {
  const absAmount = Math.abs(amount);
  return absAmount >= 100000000
    ? (amount / 100000000).toFixed(digits) + "亿"
    : absAmount >= 10000
      ? (amount / 10000).toFixed(digits) + "万"
      : amount.toFixed(digits);
}

export function noFormat(amount) {
  return String(amount);
}


// 值类型
const KEY_VALUE_TYPE = {
  m100: [
    // 转换为百分比，需要乘以100
    "changeRate", // 涨幅
    "threeMinRise", // 涨速
    "turnoverRate", // 换手率
    "amplitudeRate", // 振幅
    "orderRatio", // 委比
    "ROE", // ROE
    "openChangeRate", // 开盘涨幅
    "point_per",
    "PL",
    "todayPL"
  ],
  amount: [
    // 大数据处理带万、亿单位的
    "volume", // 成交量
    "amount", // 成交额
    "capitalization", // 总股本
    "circulatingShare", // 流通股
    "totalValue", // 总市值
    "flowValue", // 流通市值
    "sellVolume", // 内盘
    "buyVolume" // 外盘
  ],
  // 涨跌幅，涨跌
  sign: ["changeRate", "change"], // 带正负号的
  notConvert: ["block", "point", "rank", "rank_change", "block_id", "chang30"] // 不需要转换小数
};




/**
 *
 * @param {{value, key, digits, ignore, onlyFixed}} data 必要参数
 * @returns
 */
export function getValue(data = {}) {
  const { value, key, digits, ignore, onlyFixed } = data;

  if (isNaN(value) || typeof value !== "number" || ignore) return value;
  if (onlyFixed) {
    return preciseRound(value, digits);
  }

  for (const type in KEY_VALUE_TYPE) {
    const keys = KEY_VALUE_TYPE[type];
    if (keys.includes(key)) {
      switch (type) {
        case "m100":
          return preciseRound(value * 100, digits);
        case "amount":
          return formatAmount(value);
        case "notConvert":
          return noFormat(value);
        default:
          return preciseRound(value, digits);
      }
    }
  }

  return preciseRound(value, digits);
}

/**
 * 格式化数字 带万、亿单位 有单位的情况下 数字大于三位数时显示整数
 * @param {*} number
 * @returns
 */
export function formatNumberWithUnit(number, digits = 2) {
  const absAmount = Math.abs(number);
  return absAmount >= 100000000 ? (number / 100000000).toFixed(digits) + "亿"
    : absAmount >= 10000 ? (number / 10000).toFixed(digits) + "万"
    : (number ? number.toFixed(digits) : "0.00");
}

export function dataSqrt (val) {
  //  如果1开根号等于0.5， 0开根就是0.，大于0的直接开根号，小于0的先开再乘以-1
  //  开根号三次方
  if (val === 1) {
    return "0.50";
  } else if (val === 0) {
    return "0.00";
  } else if (val > 0) {
    return Math.cbrt(val).toFixed(2);
  } else {
    return (-Math.cbrt(-val)).toFixed(2);
  }
}

// 公共方法：处理对象中的空值
export function handleEmptyValues(obj) {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      // 检查是否为 null, undefined, 空字符串 或 空数组
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      ) {
        obj[key] = "--";
      }
    }
  }
  return obj;
}

// 拆分股票代码 股票后缀
export function getBeforeDot(str) {
  return str.split(".")[0];
}



// 根据值获取类名
export function getClassForValue(value) {
  if (value > 0) return "rise";
  else if (value < 0) return "fall";
  return "falt";
}
export function getClassForValue2(value) {
  if (value > 0) return "linear1";
  else if (value < 0) return "linear2";
  return "linear3";
}





/**
 * 转换股票代码后缀
 * @param {string} stockCode 股票代码 (如 "000001.SH")
 * @returns {string} 转换后的代码 (如 "000001.XSHE")
 */
export function convertStockCodeSuffix(stockCode) {
  if (typeof stockCode !== "string") {
    throw new Error("股票代码必须是字符串");
  }
  return stockCode
    .replace(/\.SZ$/, ".XSHE") // 将.SZ替换为.XSHE
    .replace(/\.SH$/, ".XSHG"); // 将.SH替换为.XSHG
}

/**
 * 将类似 20250607 的字符串或数字转换为 YYYY-MM-DD 格式
 * @param {string|number} input - 输入的日期值
 * @returns {string} 格式化后的日期字符串
 */
export function formatDateFromNumber(input) {
  // 转为字符串
  const str = String(input).trim();
  // 检查是否为8位数字
  if (!/^\d{8}$/.test(str)) {
    throw new Error("输入必须是8位数字组成的字符串或数字，例如：20250607");
  }
  // 分割年、月、日
  const year = str.substring(0, 4);
  const month = str.substring(4, 6);
  const day = str.substring(6, 8);

  return `${year}-${month}-${day}`;
}
